import { canv } from "@/canv/global";

export const getTemplateSrc = () => {
    const apiSsl = canv.getInitDataProp("isSSL") ? "https" : "http";
    return `${apiSsl}://${canv.getInitDataProp("appDomain")}/api/v2/static/preview/`;
};
